import React, {useEffect} from 'react';
import {NavFooter} from "./NavFooter";
import logo from "../assets/logo.png";

export function EffectiveDate({
                                  step,
                                  isAgent,
                                  maPlanId,
                                  maPlans,
                                  textModel,
                                  lastStep,
                                  onChange,
                                  effectiveDate = '',
                                  setEffectiveDate = () => {}
                              }) {
    const display = step === 2 ? '' : 'hidden';
    const printSOA = isAgent === 'yes' ? 'break-before' : '';
    const defaultEffectiveDate = maPlans?.find(x => x.planId === maPlanId)?.defaultEffectiveDate;

    const formatter = new Intl.DateTimeFormat('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });

    const effectiveDates = maPlans?.find(x => x.planId === maPlanId)?.effectiveDateOptions
        ?.map(x => ({
            value: x.effectiveDate,
            display: formatter.format(new Date(x.effectiveDate))
        }))
        .sort((a, b) => a.value === defaultEffectiveDate ? -1 : b.value === defaultEffectiveDate ? 1 : 0);

    useEffect(() => {
        if (defaultEffectiveDate && effectiveDates?.length > 0 && !effectiveDate) {
            setEffectiveDate(defaultEffectiveDate);
        }
    }, [defaultEffectiveDate, effectiveDate, setEffectiveDate, maPlanId]);

    return (
        <form className={`container ${display} print ${printSOA}`} style={{minHeight: '50vh'}} id="effectiveDate">
            <div className="row mt-5 hidden print">
                <div className="col">
                    <img src={logo} alt="Logo"/>
                </div>
            </div>
            <div className="row mt-3 mb-2">
                <div className="col">
                    <label className="semi-bold mb-0" htmlFor="effectiveMonth">Desired Effective Month</label>
                </div>
            </div>
            {(!effectiveDates || effectiveDates?.length === 0) && 
                <div className="row border-left border-right border-bottom align-items-center py-2 m-0">
                    No effective dates available for this plan.
                </div>
            }
            {effectiveDates && effectiveDates.map((x, index) => {
                return (
                    <React.Fragment key={x.value}>
                        {index === 1 &&
                            <div className="row border-left border-right py-2 m-0 bg-light">
                                <div className="col">
                                    <span className="mb-0">You may also be able to start coverage on the following dates:</span>
                                </div>
                            </div>
                        }
                        <div className="row border-left border-right border-bottom align-items-center py-2 m-0">
                            <div className="col-md-3">
                                <span className="font-weight-bold">{x.display}</span>
                            </div>
                            <div className="col-md-7">
                                <span className="mb-0">Your coverage will begin on {x.display}.</span>
                            </div>
                            <div className="col-md-2 text-right">
                                <label className={x.value === effectiveDate ? 'btn btn-danger w-100 mb-0' : 'btn btn-outline-danger w-100 mb-0'}>
                                    <input
                                        type="radio"
                                        name="effectiveDate"
                                        value={x.value}
                                        checked={x.value === effectiveDate}
                                        onChange={() => setEffectiveDate(x.value)}
                                        required
                                        style={{ opacity: 0, position: 'absolute', zIndex: -1 }}
                                    />
                                    {x.value === effectiveDate ? 'Selected' : 'Select'}
                                </label>
                            </div>
                        </div>
                    </React.Fragment>)
            })
            }
            <NavFooter step={step}
                       lastStep={lastStep}
                       display={step === 2}
                       disabled={!effectiveDate}
                       onChange={onChange}/>
        </form>
    );
}